import * as React from "react";

import {
  Show,
  SimpleShowLayout,
  ShowProps,
  FunctionField,
  TextField,
  DateField,
  BooleanField,
  NumberField, TopToolbar, EditButton
} from "react-admin";
import { getTags } from './ProductUtil'

const ListActions = (props: any) => {
  return (
    <TopToolbar>
      <EditButton record={props.data} label="ویرایش" />
      {/* Add your custom actions */}
    </TopToolbar>
  )
};

export const ProductShow = (props: ShowProps): React.ReactElement => {
  return (
    <Show actions={<ListActions />} {...props}>
      <SimpleShowLayout>
        <TextField label="عنوان" source="title" />
        <TextField label="توضیحات" source="description" />
        <FunctionField
          label="قیمت"
          render={(record: any) => record.price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
        />;
        <FunctionField
          label="مبلغ تخفیف"
          render={(record: any) => record.offValue?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
        />;
        <TextField label="واحد" source="currency" />

        {/* <FunctionField
          label="تگ‌ها"
          render={(record: any) => getTags(record.meta)}
        />; */}
        <TextField label="زیر عنوان" source="meta.subtitle" />
        <NumberField source="expiryPeriod" label="تاریخ انقضا سبد خرید" />
        <TextField source="name" label="کد محصول" />
        <TextField label="ایجاد کننده" source="createdBy" />
        <DateField source="createdAt" label="تاریخ ایجاد" locales="fa-IR" />
        <BooleanField source="isEnabled" label="فعال" />
      </SimpleShowLayout>
    </Show>
  );
};
